import React , {Component} from 'react';
import { fetchData3d,postData3d, deleteData3d } from '../../api/data3d';
import MUIDataTable from "mui-datatables";
import Button from '@material-ui/core/Button';
import BorderColorTwoToneIcon from '@material-ui/icons/BorderColorTwoTone';
import TextField from '@material-ui/core/TextField';
import Card from '@material-ui/core/Card';

class AddData3d extends Component{

  constructor(props) {
    super(props);
    this.state = {
      data: this.props.data,
      data3d: [],
      updateSelected:"",
      extrude: "",
      geojson: "",
      geom:"",
      y_centroid: "",
      x_centroid: "",
      pathGltf:"",
      url:"",
      code:this.props.data[3],
      featureCatalog:"",
      typeName:""
    }
  }

  componentWillMount(){

    fetchData3d(this.state.data[3])
      .then(response => {
        this.setState({data3d: response.data})
      }).catch(error => {
        console.log(error);
      });

  }

  handleUpdate = ()=>{
    console.log("sad");
  }

  submitForm = (e)=>{
    if(this.state.updateSelected == ""){
      postData3d(this.state)
        .then(response => {
          //this.props.pushCategory(response.data);
        })
        .catch(error => {
          console.log(error);
        });
    }else{
      console.log("edit ");
    }
    this.props.handleOpen(false);
    this.props.handleReload(true);
  }

  handleChangeText = (keys,e) => {
      this.setState({ [keys]: e.target.value });
  };

  handleDelete = (e) => {

    console.log(e.data[0]);
    console.log(this.state.data3d[e.data[0].index].data3dId);

    let data3dId = this.state.data3d[e.data[0].index].data3dId;

    deleteData3d(data3dId)
      .then(response => {
        console.log("deleted");
      })
      .catch(error => {
        console.log(error);
      });



  }

  render(){
    const options = {
      filterType: 'checkbox',
      onRowsDelete: this.handleDelete
    };
    const columns = [

      {name:"code"},
      {name:"extrude"},
      {name:"featureCatalog", options: {display:false}},
      {name:"typeName", options: {display:false}},
      {name:"geom", options: {display:false}},
      {name:"geojson"},
      {name:"pathGltf"},
      {name:"url"},
      {name:"x_centroid"},
      {name:"y_centroid"}

    ];

    return (
      <div>
        <Card style = {{padding:10}}>
          <TextField
            id="standard-full-width"
            label="Extrude"
            value = {this.state.extrude}
            style={{ margin: 8 }}
            placeholder="Extrude"
            helperText="Integer"
            onChange = {(e) => this.handleChangeText("extrude",e)}
            margin="normal"
            InputLabelProps={{
              shrink: true,
            }}
          />
          <TextField
            id="standard-full-width"
            label="Url"
            value = {this.state.url}
            style={{ margin: 8 }}
            placeholder="url"
            helperText="String"
            onChange = {(e) => this.handleChangeText("url",e)}
            margin="normal"
            InputLabelProps={{
              shrink: true,
            }}
          />
          <TextField
            id="standard-full-width"
            label="x_centroid"
            value = {this.state.x_centroid}
            style={{ margin: 8 }}
            placeholder="x_centroid"
            helperText="Integer"
            onChange = {(e) => this.handleChangeText("x_centroid",e)}
            margin="normal"
            InputLabelProps={{
              shrink: true,
            }}
          />
          <TextField
            id="standard-full-width"
            label="y_centroid"
            value = {this.state.y_centroid}
            style={{ margin: 8 }}
            placeholder="y_centroid"
            helperText="Integer"
            onChange = {(e) => this.handleChangeText("y_centroid",e)}
            margin="normal"
            InputLabelProps={{
              shrink: true,
            }}
          />
          <TextField
            id="standard-full-width"
            label="pathGltf"
            value = {this.state.pathGltf}
            style={{ margin: 8 }}
            placeholder="pathGltf"
            helperText="String"
            onChange = {(e) => this.handleChangeText("pathGltf",e)}
            margin="normal"
            InputLabelProps={{
              shrink: true,
            }}
          />

          <TextField
            id="filled-full-width"
            label="GeoJson"
            style={{ margin: 8 }}
            placeholder="Geom"
            helperText="GeoJSON Format "
            fullWidth
            value = {this.state.geojson}
            onChange = {(e) => this.handleChangeText("geojson",e)}
            margin="normal"
            InputLabelProps={{
              shrink: true,
            }}
            variant="filled"
          />
          <Button variant="contained" color="primary" onClick = {this.submitForm}>Add</Button>
        </Card>
        <br/>
        <MUIDataTable
        title={`Data 3D ${this.state.data[3]}`}
        data={this.state.data3d}
        columns={columns}
        options={options}
        />
      </div>
    )
  }
}

export default AddData3d
